import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "bvl-form-alert",
  templateUrl: "./form-alert.component.html",
})
export class BvlFormAlertComponent {
  @Input() type: "success" | "error" = "error";
  @Output() onClose = new EventEmitter();

  constructor() {}

  closeAlert() {
    this.onClose.emit()
  }
}
